import { Flex, Box, BoardColumnWrapper } from 'shared';

import {
  GoalBreakdownTitle,
  GoalBreakdownHeaderMenu,
  GoalBreakdownContent,
} from 'features/goal';

export const GoalBreakdownBoard = () => (
  <Flex
    flexDirection="column"
    width="100%"
    height="100%"
    gap="var(--spacing02)"
  >
    <Flex width="100%" justifyContent="space-between" alignItems="center">
      <GoalBreakdownTitle />
      <GoalBreakdownHeaderMenu />
    </Flex>
    <Box width="100%" height="100%" overflowY="auto">
      <BoardColumnWrapper fraction={1}>
        <GoalBreakdownContent />
      </BoardColumnWrapper>
    </Box>
  </Flex>
);
